/*
  Typography specifications
 */

export const typography = {
  fontFamily: 'Lato',

  h1: {
    fontSize: '1.5rem',
    fontWeight: 800,
    lineHeight: 'normal',
  },
  h2: {
    fontSize: '28px',
    fontWeight: 800,
    letterSpacing: '1.4px',
    lineHeight: 'normal',
  },
  h3: {
    fontSize: '20px',
    fontWeight: 800,
    letterSpacing: '1px',
    lineHeight: 'normal',
  },
  h6: {
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    lineHeight: 'normal',
  },
  subtitle1: {
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0.8px',
    lineHeight: 'normal',
  },
  subtitle2: {
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '0.7px',
    lineHeight: 'normal',
  },
  body1: {
    fontSize: '16px',
    fontWeight: 'normal',
    letterSpacing: '0.8px',
    lineHeight: 'normal',
  },
  body2: {
    fontSize: '12px',
    fontWeight: 'normal',
    letterSpacing: '0.5px',
    lineHeight: 'normal',
  },
};
